export const urls = {
  root: '/',
  settings: '/settings',
  accountType: '/type',
  accountDetails: '/details',
  company: '/company',
};
